import { ComponentProps } from "react";
import { Field, FieldError } from "../ui/field";

export type FieldProps = {
  label?: string;
  description?: string;
  /**
   * Additional error messages, merged with the errors of `fieldName` in the
   * ErrValidationFailedContext. Use it for errors of another source.
   */
  errors?: string[];
  /**
   * The key of the field in the nearest ErrValidationFailedContextProvider,
   * e.g. "contact.email". The field displays its errors and resets them
   * whenever the user changes the value. Without it, only `errors` is shown.
   */
  fieldName?: string;
  fieldProps?: ComponentProps<typeof Field>;
};

export function FieldErrors({ errors }: { errors?: string[] }) {
  if (!errors) {
    return null;
  }

  return (
    <>
      {errors.map((errMsg) => (
        <FieldError key={errMsg}>{errMsg}</FieldError>
      ))}
    </>
  );
}

export type DebounceProps = {
  /**
   * Whether keystrokes are buffered and reported once the user pauses.
   * Defaults to true — see {@link InputDebounced} for why.
   *
   * Set to false when the caller needs every keystroke as it happens: live
   * validation, a character counter, search-as-you-type.
   */
  debounce?: boolean;
  /** Debounce delay in milliseconds. Ignored when `debounce` is false. */
  delay?: number;
};
